import { App } from 'vue'
import DateRangePicker from './LpDateRangePicker.vue'

// @ts-ignore
DateRangePicker.install = (Vue: App) => {
  Vue.component(DateRangePicker.name, DateRangePicker)
}

export default DateRangePicker
